export const PaymentTypes = {
  CreditCard: 1,
  Cash: 2,
  PaymentLink: 3,
};

export const InvoiceStatus = {
  Paid: 1,
  Overdue: 2,
  Cancel: 3,
  Due: 4,
};

export const InvoiceStatusDescription = {
  Paid: 'Paid',
  Overdue: 'Overdue',
  Cancel: 'Cancelled',
  Due: 'Due',
};

export const CustomerStatus = {
  Prospect: 1, //prospect
  Lead: 2, //leads
  Customer: 3, //customers with earning
  Advocate: 4, //loyal customers with earning
  Due: 'Due',
};

export const ContactSources = {
  System: 1,
  CsvImports: 2,
  Facebook: 3,
  Instagram: 4,
  GoogleImports: 5,
  Booking: 6,
};


export const EmailTemplateIds = {
  reviewRequestTemplateId: 3,
};

export const snackBarType = {
  Info: 'info', //Info
  Success: 'success', //Success
  Error: 'error', //Error
  Warning: 'warning', //Warning
};

export const RenderFor = {
  LabelAssign: 'assignLabel',
  LabelRemove: 'removeLabel',
  LabelUpdate: 'setColor',
  LabelDelete: 'deleteLabel',
  StateDropDown: 'stateDropDown',
  TimezoneDropDown: 'timezoneDropDown',
  TimeZoneDropDownBusinessHours: 'timezonedropdownbusinesshours',
  CountryDropDown: 'countryDropDown',
  ContactDropDown: 'contactDropDown',
  ContactFilterDropDown: 'ContactFilterDropDown',
  ContactInvoiceDropDown: 'ContactInvoiceDropDown',
  Reviews: 'Reviews',
  Payments: 'Payments',
  LabelFilterDropDown: 'labelFilterDropDown',
  PaymentDiscountDropDown: 'paymentDiscountDropDown',
  AddPaymentMethod: 'addPaymentMethod',
  UpdatePaymentMethod: 'updatePaymentMethod',
  ContactBookingDropDown: 'ContactBookingDropDown',
  ServiceDropDown: 'ServiceDropDown',
  StructureServiceDropDown: 'StructureServiceDropDown',
  TimeDropDown: 'TimeDropDown',
  TimeDropDownbusiness: 'TimeDropDownbusiness',
  CategoryDropdown: 'CategoryDropDown',
  BussinessCategoryDropdown: 'BussinessCategoryDropDown',
  BookingTimeDropDown: 'BookingTimeDropDown',
  BusinessUserInfo: 'business-user-info',
  AuthorizeConnection: 'authorize-connection',
  StripeConnection: 'stripe-connection',
  FacebookConnection: 'facebook-connection',
  InstagramConnection: 'instagram-connection',
  GoogleConnection: 'google-connection',
  BookingTimeDropDown1: 'BookingTimeDropDown111111111111111',
  MetaSavedAudienceDropdown: 'MetaSavedAudienceDropdown',
  MetaAdDetailsGrid: 'meta-ad-details-grid',
  ctaDropDown: 'ctaDropDown',
  budgetTypeDropDown: 'budgetTypeDropDown',
  budgetTimeDropDown: 'budgetTimeDropDown',
  AdCampaignGoalDropdown: 'AdCampaignGoalDropdown',
  AdCampaignChallengeDropdown: 'AdCampaignChallengeDropdown',
};

export const SnackBarConfig = {
  Timer: '2000',
  VerticalPosition: 'verticalPosition',
  HorizontalPostion: 'horizontalPostion',
  CheckCircleIcon: 'check-circle',
  XCircleIcon: 'x-circle',
};

export const BusinessIntegrations = {
  Stripe: 1, //Stripe
  StripeName: 'Stripe',
  AuthorizeNET: 2, //AuthorizeNET
  AuthorizeNetName: 'Authorize.Net',
  FacebookMessenger: 3, //AuthorizeNET
  Instagram: 4, //Instagram
  GoogleBusiness: 5, //GoogleBusiness
};

export const DialogActions = {
  ConnectAuthorize: 'ConnectAuthorize', //connectAuthorize
  ConnectStripe: 'ConnectStripe', // connectStripe
  ConnectGoogle: 'ConnectGoogle', // connectStripe
  Yes: 'Yes', //Yes
  No: 'No', //No
  Cancelled: 'Cancelled', //Cancelled
  KeepExisting: 'keepExisting'
};

export enum ImageSourceType {
  Single = 1,
  Two = 2
}

export enum ImageCreativeGenerationSteps {
  SetYourGoal = 2,
  Editor = 3
}

export enum Modules {
  contactModuleId = 1,
  paymentModuleId = 2,
  inboxModuleId = 3,
  reviewModuleId = 4,
}

export enum Sources {
  System = 1,
  CsvImports = 2,
  Facebook = 3,
  Instagram = 4,
  GoogleImports = 5,
  Booking = 6,
}

export enum Validtors {
  None = 1,
  Required = 2,
  InvalidStartTime = 3,
  StartTimeEqualsEndTime = 4,
  Overlap = 5
}

export enum ErrorTypes {
  None = 1,
  Required = 2,
  InvalidStartTime = 3,
  StartTimeEqualsEndTime = 4,
  Overlap = 5
}

export enum MessageStatuses {
  Sent = 1,
  Delivered = 2,
  Read = 3,
  NotDelivered = 4,
}

export const BatchActivity = {
  ContactCreated: 'Contact Created',
  ContactUpdated: 'Contact Updated',
};

export const BatchActivityId = {
  ContactCreatedId: 1,
  ContactUpdatedId: 2,
};

export enum WorkingEnvironment {
  Local = 'local',
  Development = 'development',
  QA = 'qa',
  Staging = 'staging',
  Production = 'production',
}

export const DiscountTypes = {
  Percent: 1,
  Fixed: 2,
  Coupon: 3,
};

export const DiscountStatuses = {
  Active: 'Active',
  Inactive: 'Inactive'
};

export enum AdvancedPaymentTypes {
  Percentage = 1,
  Fixed = 2,
}

export enum BookingStatus {
  Scheduled = 1,
  WaitingForPayment = 2,
  MarkedAsNoShow = 3,
  Cancelled = 4,
  Completed = 5,

};

export const DiscountTypesString = {
  Percentage: 'percentage',
  Fixed: 'fixed',
};

export const PaymentMode = {

  CreditcardMode: 'creditcardMode',
  CashMode: 'cashMode',
  LinkMode: 'linkMode',
};

export const BookingSettingsTabs = {
  GeneralSettings: 0,
  BusinessPolicy: 1
};



//#region Meta Ads



export const AdObjectives = {
  Messages: 1,
  Lead: 2,
  Website: 8
};

// export const AdStatus = {
//   Active: "ACTIVE",
//   Paused: "PAUSED",
// }

// export const GridAdStatus = {
//   Active: "Active",
//   Paused: "Paused",
// }

//export const PreviousScreen = {
//  AdsListing: "AdsListing",
//  AdDetails: "AdDetails"
//}



export enum PreviewFeed {
  BIZ_DISCO_FEED_MOBILE = 'BIZ_DISCO_FEED_MOBILE',
  DESKTOP_FEED_STANDARD = 'DESKTOP_FEED_STANDARD',
  FACEBOOK_PROFILE_FEED_DESKTOP = 'FACEBOOK_PROFILE_FEED_DESKTOP',
  FACEBOOK_PROFILE_FEED_MOBILE = 'FACEBOOK_PROFILE_FEED_MOBILE',


  // video feed facebook

  WATCH_FEED_HOME = 'WATCH_FEED_HOME',
  WATCH_FEED_MOBILE = 'WATCH_FEED_MOBILE',

  MOBILE_FEED_BASIC = 'MOBILE_FEED_BASIC',
  MOBILE_FEED_STANDARD = 'MOBILE_FEED_STANDARD',
  MOBILE_FULLWIDTH = 'MOBILE_FULLWIDTH',
  MOBILE_INTERSTITIAL = 'MOBILE_INTERSTITIAL',
  MOBILE_MEDIUM_RECTANGLE = 'MOBILE_MEDIUM_RECTANGLE',
  MOBILE_NATIVE = 'MOBILE_NATIVE',

  // Reels

  FACEBOOK_REELS_BANNER = 'FACEBOOK_REELS_BANNER',
  FACEBOOK_REELS_BANNER_DESKTOP = 'FACEBOOK_REELS_BANNER_DESKTOP',
  FACEBOOK_REELS_MOBILE = 'FACEBOOK_REELS_MOBILE',
  FACEBOOK_REELS_POSTLOOP = 'FACEBOOK_REELS_POSTLOOP',
  FACEBOOK_REELS_STICKER = 'FACEBOOK_REELS_STICKER',
  FACEBOOK_PROFILE_REELS_MOBILE = 'FACEBOOK_PROFILE_REELS_MOBILE',
  INSTAGRAM_REELS = 'INSTAGRAM_REELS',
  INSTAGRAM_REELS_OVERLAY = 'INSTAGRAM_REELS_OVERLAY',

  // Story
  FACEBOOK_STORY_MOBILE = 'FACEBOOK_STORY_MOBILE',
  FACEBOOK_STORY_STICKER_MOBILE = 'FACEBOOK_STORY_STICKER_MOBILE',
  INSTAGRAM_STORY = 'INSTAGRAM_STORY',

  // Instagram profile feed
  INSTAGRAM_STANDARD = 'INSTAGRAM_STANDARD',
  INSTAGRAM_PROFILE_FEED = 'INSTAGRAM_PROFILE_FEED',

  INSTAGRAM_EXPLORE_CONTEXTUAL = 'INSTAGRAM_EXPLORE_CONTEXTUAL',
  INSTAGRAM_EXPLORE_GRID_HOME = 'INSTAGRAM_EXPLORE_GRID_HOME',
  INSTAGRAM_EXPLORE_IMMERSIVE = 'INSTAGRAM_EXPLORE_IMMERSIVE',

  // Instagram story

  INSTAGRAM_SEARCH_CHAIN = 'INSTAGRAM_SEARCH_CHAIN',
  INSTAGRAM_SEARCH_GRID = 'INSTAGRAM_SEARCH_GRID',

  // instream 

  INSTREAM_BANNER_DESKTOP = 'INSTREAM_BANNER_DESKTOP',
  INSTREAM_BANNER_FULLSCREEN_MOBILE = 'INSTREAM_BANNER_FULLSCREEN_MOBILE',
  INSTREAM_BANNER_IMMERSIVE_MOBILE = 'INSTREAM_BANNER_IMMERSIVE_MOBILE',
  INSTREAM_BANNER_MOBILE = 'INSTREAM_BANNER_MOBILE',
  INSTREAM_VIDEO_FULLSCREEN_IOS = 'INSTREAM_VIDEO_FULLSCREEN_IOS',
  INSTREAM_VIDEO_FULLSCREEN_MOBILE = 'INSTREAM_VIDEO_FULLSCREEN_MOBILE',
  INSTREAM_VIDEO_IMMERSIVE_MOBILE = 'INSTREAM_VIDEO_IMMERSIVE_MOBILE',
  INSTREAM_VIDEO_MOBILE = 'INSTREAM_VIDEO_MOBILE',
}
export enum MetaAdLabels {
  Xoopah = 1
}

export enum MetaAdEffectiveStatusEnum {
  ACTIVE = 1,
  PAUSED = 2,
  PENDING_REVIEW = 3,
  CREDIT_CARD_NEEDED = 4,
  PREAPPROVED = 5,
  DISABLED = 6,
  PENDING_PROCESS = 7,
  WITH_ISSUES = 8,
  COMPLETED = 9,
  DISAPPROVED = 10,
  PENDING_BILLING_INFO = 11,
  CAMPAIGN_PAUSED = 12,
  ARCHIVED = 13,
  ADSET_PAUSED = 14,
  IN_PROCESS = 15,

  // CUSTOM STATUSES FOR FRONTEND
  // Note: We are starting with 50 to avoid any conflict with Meta's statuses.
  UNKNOWN = 50,
  RUNNING = 51,
  SCHEDULED = 52,
  DRAFT = 53,
}

export enum MetaAdEffectiveStatusString {
  ACTIVE = "Active",
  PAUSED = "Paused",
  PENDING_REVIEW = "In-Review",
  CREDIT_CARD_NEEDED = "Credit Card Needed",
  PREAPPROVED = "Pre-Approved",
  DISABLED = "Disabled",
  PENDING_PROCESS = "Pending Process",
  WITH_ISSUES = "Error",
  COMPLETED = "Completed",
  DISAPPROVED = "Disapproved",
  PENDING_BILLING_INFO = "Update Billing Info",
  CAMPAIGN_PAUSED = "Paused",
  ARCHIVED = "Archived",
  ADSET_PAUSED = "Paused",
  IN_PROCESS = "In Process",

  // CUSTOM STATUSES FOR FRONTEND
  // Note: We are starting with 50 to avoid any conflict with Meta's statuses.
  UNKNOWN = "Unknown",
  RUNNING = "Running",
  SCHEDULED = "Scheduled",
  DRAFT = "Draft",
}

export enum MetaAdStatusEnum {
  // UNKNOWN is not meta's status, but our custom status.
  UNKNOWN = 0,

  ACTIVE = 1,
  PAUSED = 2,
  DELETED = 3,
  ARCHIVED = 4
}


export enum MetaAdInsightsDatePresetEnum {
  Today = 1,
  Yesterday = 2,
  ThisWeek = 3,
  LastWeek = 4,
  ThisMonth = 5,
  LastMonth = 6,
  ThreeMonths = 7,
  LastThreeMonths = 8,
  SixMonths = 9,
  LastSixMonths = 10,
  AllTime = 11
}


export enum TargetingStrategyTypes {
  Retargeting = 1,
  Lookalike = 2,
  Both = 3
}

export enum SimilarityTypes {
  ExactMatch = 1,
  Similar = 2,
  SlightlySimilar = 3
}

export enum AudienceSources {
  CurrentPageAudience = 1,
  CustomerList = 2
}

//TODO: move these enums to a proto service to mantain a single source of truth
export enum BusinessBackgroundJobType {
  MetaAdsData = 1,
}

export enum SyncAuthor {
  System = 1,
  Manual = 2
}

export enum AdAccountStatus {
  /// <summary>
  /// <strong>Warning:</strong> This is our custom enum value and doesn't come from Meta's API docs.
  /// </summary>  
  UNKNOWN = 0,

  ACTIVE = 1,
  DISABLED = 2,
  UNSETTLED = 3,
  PENDING_RISK_REVIEW = 7,
  PENDING_SETTLEMENT = 8,
  IN_GRACE_PERIOD = 9,
  PENDING_CLOSURE = 100,
  CLOSED = 101,
  ANY_ACTIVE = 201,
  ANY_CLOSED = 202
}

//#endregion



export enum InputValidators {
  Required = 'required',
  MinLength = 'minLength',
  MaxLength = 'maxLength',
  Pattern = 'pattern',
  Email = 'email',
  Password = 'password',


}


export enum MetaAdTypes {
  Prospect = 1,
  Retargeting = 2
}

export enum MetaAdDestinations {
  MESSENGER = 1,
  INSTAGRAM_DIRECT = 2,
  MESSAGING_INSTAGRAM_DIRECT_MESSENGER = 3,
  ON_AD = 4,
  WEBSITE = 5,
  ON_VIDEO = 6,
  MESSAGING_INSTAGRAM_DIRECT_MESSENGER_WHATSAPP = 7,
  MESSAGING_MESSENGER_WHATSAPP = 8,
  PHONE_CALL = 9
}

//#region UGC Creative

export enum UgcGenerationStatusEnum {
  Draft = 1,
  Generating = 2,
  Completed = 3,
  Failed = 4
}

export enum ImageCreativeGenerationStatuses {
  Draft = 1,
  Completed = 2,
  InProgress = 3,
}

export enum CreativeTypes {
  UgcVideo = 1,
  StaticCreative = 2,
  AIStaticCreative = 3,
  AIVideo = 4
}

export enum AICreativeTypes {
  SingleAsset = 1,
  MultiAsset = 2,
  TextOnly = 3
}


//#endregion

export enum InAppFeedbackModulesEnum {
  SubscriptionCancelation = 1,
  InAppFeedback = 2,
  WithAvatarVideo = 3,
  WithoutAvatarVideo = 4,
  StaticCreative = 5,
  AIRemix = 6,
  Ads = 7
}

export enum CreativeVideoTypeEnum {
  WithAvatarVideo = 1,
  WithoutAvatarVideo = 2,
}

export enum UgcCreativeAvatarProviderEnum {
  HeyGen = 1,
  Kling = 2
}

export const GuestSources = {
  UGC: 'ugc',
  Voiceover: 'voiceover',
  Static: 'static',
  AIStatic: 'aistatic'
}

export const OTPTypes = {
  LogIn: 1,
  SignUp: 2,
  PasswordReset: 3,
  AddPassword: 4
}

